import { Box } from "@mui/material";

export function ComparisonValue({
	value,
	compact = false,
}: {
	value: string | null;
	compact?: boolean;
}) {
	if (value === null || value.trim() === "") {
		return (
			<Box
				component="span"
				sx={{ color: "text.secondary", fontStyle: "italic" }}
			>
				{value === null ? "NULL" : "empty"}
			</Box>
		);
	}
	if (compact && value.length > 60) {
		return <span title={value}>{value.slice(0, 60)}…</span>;
	}
	return value;
}
